import DisclaimerWrapper from '../common/components/DisclaimerWrapper';
import PageWrapper from '../common/layouts/PageWrapper';
import { useDebtorPartiesPage } from '../features/search/debtor-parties/use-debtor-parties-page';
import { useSearchPageQueryParams } from '../features/search/useSearchPageQueryParams';
import { UCCSearchOptionType } from '../features/search/types';
import { PageTitle } from '../common/constants/features-constants';
import DebtorSecuredList from '../features/search/DebtorSecuredList';

export const UCCSearchDetailsDebtorParties = () => {
  const { uccNumber, rn, searchOptionType, searchOptionSubOption, searchCategory, text } =
    useSearchPageQueryParams();
  const { fileData, isLoading } = useDebtorPartiesPage(
    searchOptionType ?? UCCSearchOptionType.DocumentNumber,
    uccNumber ?? undefined,
    rn,
    searchOptionSubOption,
    searchCategory,
    text
  );

  return (
    <DisclaimerWrapper>
      <PageWrapper title="UCC Search" headTitle={PageTitle.DEBTOR_LISTING}>
        <DebtorSecuredList
          title="Debtor Parties For"
          isLoading={isLoading}
          uccNumber={uccNumber ?? fileData?.uccNumber}
          data={fileData?.debtors}
        />
      </PageWrapper>
    </DisclaimerWrapper>
  );
};
